export default function(el) {
  return el.querySelectorAll(this.options.elements)
}
